<div *ngIf="imageURL" class="sb-prematch-item--icon">
  <img [src]="imageURL" class="sb-prematch-item--icon-image" alt="Camiseta de {{ title }}" />
</div>

<p class="sb-prematch-item--title">
  {{ title }}
  <span *ngIf="subtitle" class="sb-prematch-item--subtitle color-muted">({{ subtitle }})</span>
</p>

<i class="codere-icon icon-arrow-right" *ngIf="arrow"></i>
